import { useSyncExternalStore } from 'react'
import { pubSubSidebar } from '../../state/pubSub'
import { SIDEBAR, SidebarEvent, SidebarState } from '../../state/state.sidebar'

const getSidebarSelector =
    <T extends keyof SidebarState>(key: T) =>
    () =>
        SIDEBAR.state[key]
const subSidebar = (callback: () => void) =>
    pubSubSidebar.on(SidebarEvent.STATE, callback)

export const useSidebarSelector = <T extends keyof SidebarState>(
    key: T,
): SidebarState[T] => {
    const showSidebar = useSyncExternalStore(
        subSidebar,
        getSidebarSelector(key),
        getSidebarSelector(key),
    )

    return showSidebar
}
